module.exports = __webpack_public_path__ + "img/矩形底卡.a199998f.png";